import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Terms extends Component {

  render() {
    return (
      <div>
        <h3>Pricing</h3>
        <p>
          Drip Workflows and eBlasts incur no additional costs.
        </p>
        <h3>Terms of Service</h3>
        <p>
          <em>I agree to only send emails to people who have signed up to receive emails from me.</em>
        </p>
        <h3>Suspension of Services</h3>
        <p>
          We may suspend your account at any time without prior warning or liability for any of the following reasons:
        </p>
          <ol>
            <li>
              - If you are believed to be sending abusive or excessive email.
            </li>
            <li>
              - If your emails are receiving a high amount of bounces or unsubscribes.
            </li>
            <li>
              - If you do not cooperate with our investigation of a suspected violation.
            </li>
            <li>
              - If we are required by law or by a regulatory or government body or our upstream providers to suspend your account.
            </li>
            <li>
              - If suspension of your account is required to protect our network, other customers, upstream providers, or our reputation and deliverability.
            </li>
          </ol>
        <p>
          Note: We are using a third party service to deliver all your emails. If the third party determines, based on their spam threshold, that your email is spam or abusive they may restrict your email automatically. We must abide by their guidelines. Your Drip and eBlast access may be suspended or terminated without notice.
        </p>
        <h3>Valid Email Information</h3>
        <p>
          The most common reason for account suspension is bounces or unsubscribes due to incorrect lead information or bad mailing lists. Don’t purchase your list or scrape websites for emails.
        </p>
        <h3>Unsubscribes</h3>
        <p>
          If a lead unsubscribes from a Drip Workflow or an eBlast, no future emails using either Drip Workflow or eBlast will be sent. A lead subscribed to any drip workflow will be automatically unsubscribed.
        </p>
        <h3>Delivery</h3>
        <p>
        We will make every reasonable effort to deliver your email messages, but we do not guarantee delivery. Third party filtering services and other policies of recipient email services may prevent successful delivery of your messages.
        </p>
      </div>
    );
  }
}

export default Terms;
